<p *ngIf="b2bUnitId">
  <span><i class="far fa-user-circle mr-2"></i></span>
  {{ 'headerInfo.customerNumber' | cxTranslate : { b2bUnitId: b2bUnitId } }}
</p>
